<script setup lang="ts">

import { useSalesPresentation } from './SalesPresentation';
import Presentation from '@presentation/Templates/Presentation.vue';

useSalesPresentation(); 

</script>

<template>
    <Presentation />
</template>